<template>
  <div class="page-content-wrapper"  v-check-permission="'list-user-payments'">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card m-b-20">
            <div class="card-block">

              <template v-if="payment">
                <div class="invoice-title">
                  <h4 class="mt-0 header-title">Pagos</h4>
                </div>

                <hr>

                <div class="row mb-3">
                  <div class="col-md-12">
                    <strong>Código del pago</strong> #{{ payment._id }}
                  </div>
                </div>

                <div class="row">

                  <div class="col-md-6">
                    <address>
                      <strong>Tipo de pago</strong>
                      <p>
                        <span class="badge badge-info" v-if="payment.paymentType == 'enrollment'">Matrícula</span>
                        <span class="badge badge-dark" v-if="payment.paymentType == 'custom'">Personalizado</span>
                      </p>
                    </address>
                  </div>

                  <div class="col-md-6">
                    <address>
                      <strong>Estado</strong>
                      <p>
                        <span class="badge badge-primary" v-if="payment.paymentStatus == 'pending'">Pendiente</span>
                        <span class="badge badge-success" v-if="payment.paymentStatus == 'approved'">Pagado</span>
                      </p>
                    </address>
                  </div>

                </div>

                <div class="row">

                  <div class="col-md-6">
                    <address>
                      <strong>Vencimiento</strong>
                      <p>{{ payment.dueDate | moment("dddd, DD MMMM YYYY") }}</p>
                    </address>
                  </div>

                </div>


                <div class="row">
                  <div class="col-12">
                    <div class="panel panel-default">
                      <div class="p-2">
                        <h3 class="panel-title font-20"><strong>Detalle</strong></h3>
                      </div>
                      <div class="">
                        <div class="table-responsive">
                          <table class="table">
                            <thead>
                            <tr>
                              <td><strong>Item</strong></td>
                              <td class="text-center"><strong>Carrera</strong></td>
                              <td class="text-center"><strong>Monto</strong></td>
                              <td class="text-center"><strong></strong></td>
                              <td class="text-right"><strong>Total</strong></td>
                            </tr>
                            </thead>
                            <tbody>

                            <tr>
                              <td>{{ payment.title }}</td>
                              <td class="text-center">{{ career.name }}</td>
                              <td class="text-center">${{ payment.amount }}</td>
                              <td class="text-center"></td>
                              <td class="text-right">${{ payment.amount }}</td>
                            </tr>
                            <tr>
                              <td class="thick-line"></td>
                              <td class="thick-line"></td>
                              <td class="thick-line"></td>
                              <td class="thick-line text-center">
                                <strong>Subtotal</strong></td>
                              <td class="thick-line text-right">${{ payment.amount }}</td>
                            </tr>
                            <tr>
                              <td class="no-line"></td>
                              <td class="no-line"></td>
                              <td class="no-line"></td>
                              <td class="no-line text-center">
                                <strong>Descuento</strong></td>
                              <td class="no-line text-right">-${{ discountAmount }}</td>
                            </tr>
                            <tr>
                              <td class="no-line"></td>
                              <td class="no-line"></td>
                              <td class="no-line"></td>
                              <td class="no-line text-center">
                                <strong>Recargo</strong></td>
                              <td class="no-line text-right">+${{ interestAmount }}</td>
                            </tr>
                            <tr>
                              <td class="no-line"></td>
                              <td class="no-line"></td>
                              <td class="no-line"></td>
                              <td class="no-line text-center">
                                <strong>Total</strong></td>
                              <td class="no-line text-right"><h4 class="m-0">${{ amountPaid }}</h4></td>
                            </tr>
                            </tbody>
                          </table>
                        </div>

                        <div class="hidden-print" v-if="preference">
                          <div class="pull-right">
                            <router-link to="/list-user-payments" class="btn btn-secondary waves-effect m-r-10">Cancelar</router-link>
                            <a class="btn btn-info waves-effect waves-light" v-bind:href="preference.init_point">Pagar</a>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

              </template>

              <template v-else-if="!error">

                <div class="ex-page-content text-center">
                  <h1>Aguarde un momento</h1>
                  <span><i class="fa fa-smile-o icon"></i></span>
                  <h5 class="text-muted">En unos segundos se cargaran los datos para que puedas realizar el pago.</h5>
                </div>

              </template>

              <template v-if="error">

                <div class="ex-page-content text-center">
                  <h1>Ha ocurrido un error</h1>
                  <span><i class="fa fa-frown-o icon"></i></span>
                  <h5 class="text-muted">Para volver a intentarlo presiona el siguiente botón:</h5>

                  <a class="btn btn-info" href="javascript:void(0);" @click="getData()">Pagar</a>
                </div>

              </template>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { getFeeInfo } from '../api'

  export default {
    name: 'pay-fee',


    created () {
      this.getData()
    },


    data () {
      return {
        preference: null,
        payment: null,
        discountAmount: 0,
        interestAmount: 0,
        amountPaid: 0,
        career: null,
        error: false
      }
    },


    methods: {

      getData: function () {

        this.error = false;
        this.$loader.loading();

        getFeeInfo(this.$route.params.id)
          .then((response) => {

            if(response.body.success) {

              this.preference = response.body.data.preference;
              this.payment = response.body.data.payment;
              this.discountAmount = response.body.data.discountAmount;
              this.interestAmount = response.body.data.interestAmount;
              this.amountPaid = response.body.data.amountPaid;
              this.career = response.body.data.career;

            } else {

              this.error = true;
              this.$message.error({ text: response.body.message });

            }

            this.$loader.close();
          })
          .catch(error => {
            this.$message.error({ text: error });
            this.$loader.close();
          })

      }

    }
  }
</script>


<style scoped>
  h1 {
    font-size: 3em;
    line-height: normal;
    text-shadow: none;
  }
  .icon {
    font-size: 47px;
  }
  .card {
    min-height: 80vh;
  }
  .ex-page-content {
    margin-top: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/screens/PayTuitionScreen.vue